import { GlobalAnalytics } from './SmartLook'

const analytics = new GlobalAnalytics()

export default analytics
